import Vue from "vue";
import api from "../../api/projects";

const state = {
  i18n: undefined,
  loading: false,
  projects: {
    paginator: { data: [], meta: { per_page: 10 } },
    selected: undefined,
    routes: undefined,
    statuses: undefined,
    filters: undefined,
    refreshRates: undefined,
  },
};

const actions = {
  getPaginator({ commit }, queryString) {
    let endpoint = state.projects.routes.index;

    if (queryString) {
      endpoint += "?" + queryString;
    }

    commit("setLoading", true);

    api.getProjects(endpoint, (paginator) => {
      commit("setPaginator", paginator);
    });
  },

  getProject({ commit }, projectId) {
    let endpoint = state.projects.routes.show.replace(":id", projectId);
    api.getProjectDetail(endpoint, (project) => {
      commit("updateProject", project);
    });
  },
};

const mutations = {
  setTranslations(state, i18n) {
    state.i18n = i18n;
  },
  setPaginator(state, paginator) {
    if (paginator.meta !== undefined) {
      state.projects.paginator = paginator;
    } else {
      state.projects.paginator.data = paginator.data;
      state.projects.paginator.meta = { per_page: 10 };
      state.projects.paginator.links = undefined;
    }

    state.loading = false;
  },
  addProject(state, project) {
    this.commit("account/increaseProjectsCount");

    if (
      state.projects.paginator.meta.total === undefined &&
      state.projects.paginator.data.length === 10
    ) {
      this.dispatch("dashboard/getPaginator");
    } else {
      if (
        state.projects.paginator.data.length ==
        state.projects.paginator.meta.per_page
      ) {
        state.projects.paginator.data.pop();
      }

      state.projects.paginator.data.unshift(project);
    }
  },

  increaseProjectsCount(state) {
    if (state.projects.paginator.meta.total !== undefined) {
      state.projects.paginator.meta.total += 1;
    }
  },

  updateProject(state, updated) {
    let index = getPaginatedProjectIndexById(state, updated.id);
    if (index !== undefined) {
      Vue.set(state.projects.paginator.data, index, updated);
      if (updated.safe) {
        this.commit("account/setSafe", updated.safe);
      }
    }
  },

  updateProjectFilename(state, { id, filename }) {
    let project = getPaginatedProjectById(state, id);
    let index = getPaginatedProjectIndex(state, project);
    if (index !== undefined && project) {
      // project may have been created in the background and does not exist yet
      project.filename = filename;
      Vue.set(state.projects.paginator.data, index, project);
    }
  },

  updateProjectStatus(state, { id, status }) {
    let project = getPaginatedProjectById(state, id);
    if (project) {
      let index = getPaginatedProjectIndex(state, project);
      if (index !== undefined) {
        project.status = status;
        Vue.set(state.projects.paginator.data, index, project);
      }
    }
  },

  setProjectsRoutes(state, routes) {
    state.projects.routes = routes;
  },
  setRefreshRates(state, rates) {
    state.projects.refreshRates = rates;
  },
  setProjectsStatuses(state, statuses) {
    state.projects.statuses = statuses;
  },
  setProjectsFilters(state, filters) {
    state.projects.filters = filters;
  },
  setLoading(state, booleanValue) {
    state.loading = booleanValue;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};

function getPaginatedProjectById(state, id) {
  if (state.projects.paginator !== undefined) {
    return state.projects.paginator.data.find((project) => project.id === id);
  }

  return undefined;
}

function getPaginatedProjectIndex(state, project) {
  if (state.projects.paginator !== undefined) {
    return state.projects.paginator.data.indexOf(project);
  }

  return undefined;
}

function getPaginatedProjectIndexById(state, id) {
  let project = getPaginatedProjectById(state, id);

  if (project !== undefined) {
    return getPaginatedProjectIndex(state, project);
  }

  return undefined;
}
